


export function prefixedColour(colour) {
  if (colour.indexOf('#') == 0) {
    return colour
  }
  return "#" + colour
}

export function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function invertColor(hex, bw) {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    alert(`Invalid HEX color value ${hex} Must be six hex numbers in length, e.g. #223344`)
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

export function styleFromColour(colour) {
  let style = {
    backgroundColor: prefixedColour(colour),
    color: invertColor(colour, true)
  }
  return `
  body {
    background-color: ${style.backgroundColor};
    color: ${style.color};
  }

  .social-button i {
    color: ${style.color};
  }
  .search_bar_row a {
    color: ${style.color};
  }
  `;
}

export function addStyleElement(business, menu) {

  let css = document.createElement('style');

  css.innerHTML = `
  body {
    background-color: #000000;
    color: #ffffff;
      }

     .social-button i {
        color: white;
      }
      .search_bar_row a {
        color: white;
      }
    `;

  if (business.style && business.style != "") {
    css.innerHTML = business.style
  } else if (menu.colour && menu.colour != "") {
    css.innerHTML = styleFromColour(menu.colour)
  } else if (business.colour && business.colour != "") {
    css.innerHTML = styleFromColour(business.colour)
  }

  //console.log("style", css.innerHTML)

  document.head.appendChild(css);

}

export function addStyleLink(url) {
  let link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  console.log("addStyleLink", url)
  document.head.appendChild(link);

  return link
}

export function addScriptLink(url) {
  let script = document.createElement('script');
  script.src = url;
  console.log("addScriptLink", url)
  document.head.appendChild(script);
  return script
}

export function bestStringValue(a, b) {
  if (a && a != "") {
    return a
  }
  return b
}